import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, isAuthenticated, authenticationInProgress } = useContext(AuthContext);

  // Show loading while auth is in progress or still loading
  if (loading || authenticationInProgress) {
    return (
      <div style={loadingContainer}>
        <div style={loadingSpinner}></div>
        <div style={loadingText}>Authenticating...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

const loadingContainer = {
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "radial-gradient(circle at top, #001f3f, #000814, #00040f)",
  color: "#9ecbff",
};

const loadingSpinner = {
  width: 45,
  height: 45,
  border: "5px solid rgba(255,255,255,0.2)",
  borderTopColor: "#3b82f6",
  borderRadius: "50%",
  margin: "0 auto 20px auto",
  animation: "spin 0.8s linear infinite",
};

const loadingText = {
  color: "#9ecbff",
  fontSize: 16,
  fontWeight: 500,
};

